import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";
import AdminApplications from "../../components/Admin/AdminApplications";

const NewApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="New Applications"
        status={[applicationStatusMap?.applied.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
};

export default NewApplications;
